import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import app from './app'
import user from './user'
import getNpaData from './modules/getNpaData'
import getUser from './modules/getUser'
import search from './modules/search'
import notification from './modules/notification'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    error: null
  },
  mutations: {
    setError(state, error) {
      state.error = error
    },
    clearError(state) {
      state.error = null
    }
  },
  getters: {
    error: (s) => s.error
  },
  modules: {
    auth,
    getNpaData,
    app,
    user,
    getUser,
    search,
    notification
  }
})
